// extracted by mini-css-extract-plugin
export var button = "_w-0";
export var buttonContent = "_w-e";
export var buttonGroup = "_w-c";
export var dontRestrainIconWidth = "_w-a";
export var dropdownButton = "_w-b";
export var iconContainer = "_w-9";
export var lg = "_w-4";
export var md = "_w-3";
export var pending = "_w-f";
export var sm = "_w-2";
export var spinner = "_w-d";
export var squared = "_w-8";
export var wrapText = "_w-g";
export var xl = "_w-5";
export var xs = "_w-1";
export var xxl = "_w-6";
export var xxxl = "_w-7";